<template>
  <v-form>
    <v-expansion-panels
      focusable
      id="smart-manager"
      v-model="panel"
      mt-6
      mb-4
      light
      multiple
      accordion
    >
      <SmartAgentFieldExpantionWhatJD
        :text="' בחירת תפקיד'"
        :keywordsJD="keywordsJD"
        @selectionsUpdated="handleWhatJDSelection"
        :showCategoriesMsg = "showCategories"
      />

      <SmartAgentFieldExpantionCategories
        :items="categories"
        :text="categoriesText"
        :agent-code="agentCode"
        v-show="showCategories"
      />

      <SmartAgentFieldExpantionLocation
        :text="'מיקום'"
        :locations="locations"
        @selectionsUpdated="handleLocationSelection"
      />

      <SmartAgentFieldExpantion
        :items="scope"
        :text="scopeText"
        :caution-msg="t('titles.reduceScopeMsg')"
        :show-msg-if-less-then="recomendedScope"
        @selectionsUpdated="handleScopeSelection"
      />

      <SmartAgentFieldExpantion
        :items="experience"
        :text="experienceText"
        :caution-msg="t('titles.reduceExperienceMsg')"
        :show-msg-if-less-then="recomendedExperience"
        @selectionsUpdated="handleExperienceSelection"
      />
      <SmartAgentFieldExpantionAlertTypes
        :items="alertTypes"
        :text="alertTypesText"
        :caution-msg="t('titles.alertsType')"
        :show-msg-if-less-then="1"
        @selectionsUpdated="handleAlertTypesSelection"
      />
    </v-expansion-panels>
  </v-form>
</template>

<script>
import SmartAgentFieldExpantion from '@/components/Candidates/Pages/SmartAgentManager/SmartAgentFieldExpantion';

import SmartAgentFieldExpantionLocation from '@/components/Candidates/Pages/SmartAgentManager/SmartAgentFieldExpantionLocation';
import SmartAgentFieldExpantionWhatJD from '@/components/Candidates/Pages/SmartAgentManager/SmartAgentFieldExpantionWhatJD';

import SmartAgentFieldExpantionCategories from '@/components/Candidates/Pages/SmartAgentManager/SmartAgentFieldExpantionCategories';
import SmartAgentFieldExpantionAlertTypes from '@/components/Candidates/Pages/SmartAgentManager/SmartAgentFieldExpantionAlertTypes';

import { mapState, mapActions, mapGetters } from 'vuex';


export default {
  components: {
    SmartAgentFieldExpantion,
    SmartAgentFieldExpantionCategories,
    SmartAgentFieldExpantionLocation,
    SmartAgentFieldExpantionAlertTypes,
    SmartAgentFieldExpantionWhatJD,
  },
  props: {
    agentCode: {
      type: String,
      default: null,
      required: true,
    },
    showCategories: {
      type: Boolean,
      default: false,
      required: true,
    },
  },

  data() {
    return {
      panel: [0, 1, 2],
    };
  },

  computed: {
    ...mapState({
      categories: (state) =>
        state.smartAlertsSettings.allSettingsData.Categories,
      scope: (state) => state.smartAlertsSettings.allSettingsData.ScopesList,
      locations: (state) => state.smartAlertsSettings.allSettingsData.Locations,
      keywordsJD: (state) => state.smartAlertsSettings.allSettingsData.Keywords,
      experience: (state) =>
        state.smartAlertsSettings.allSettingsData.ExperiencesList,
      alertTypes: (state) =>
        state.smartAlertsSettings.allSettingsData.AlertTypes,
      categoriesText: (state) =>
        state.smartAlertsSettings.allSettingsData.KeysDictionary.Keys[1]
          .KeyValue.Value,
      scopeText: (state) =>
        state.smartAlertsSettings.allSettingsData.KeysDictionary.Keys[10]
          .KeyValue.Value,
      experienceText: (state) =>
        state.smartAlertsSettings.allSettingsData.KeysDictionary.Keys[11]
          .KeyValue.Value,
      alertTypesText: (state) =>
        state.smartAlertsSettings.allSettingsData.KeysDictionary.Keys[15]
          .KeyValue.Value,
    }),

    scopeSelect: {
      get() {
        return this.scope;
      },
      set(val) {
        this.setScope(val);
      },
    },

    ...mapGetters({
      getLocal: 'getLocal',
      CurrentUser: 'CurrentUser',
    }),
    recomendedScope() {
      return this.scope.length;
    },

    recomendedExperience() {
      return this.experience.length;
    },
    user() {
      return this.CurrentUser;
    },
  },

  mounted() {
    this.fetchUserData();
    this.categories;
    this.closeCategories();
  },

  watch: {
    scope(val) {
      this.setScope(val);
    },
  },

  methods: {
    ...mapActions([
      'fetchUserData',
      'setScope',
      'setLocations',
      'setExperience',
      'setAlertTypes',
      'setKeywordsJD',
    ]),

    closeCategories() {
      this.panel = [0];
    },

    handleLocationSelection(selections) {
      this.setLocations(selections);
    },

    handleScopeSelection(selections) {
      this.setScope(selections);
    },

    handleExperienceSelection(selections) {
      this.setExperience(selections);
    },

    handleAlertTypesSelection(selections) {
      this.setAlertTypes(selections);
    },

    handleWhatJDSelection(selections) {
      this.setKeywordsJD(selections.trim());
    },
  },
};
</script>

<style lang="scss" scoped>
.v-icon {
  background: #fff;
  color: red !important;
}

#smart-manager
  .theme--light.v-expansion-panels.v-expansion-panels--focusable
  .v-expansion-panel-header--active:hover::before,
.theme--light.v-expansion-panels.v-expansion-panels--focusable
  .v-expansion-panel-header--active::before {
  opacity: 1 !important;
}
</style>
